module.exports = __webpack_public_path__ + "img/collection-engagementRingsCharacter.129fa0d.webp";